import { render, staticRenderFns } from "./FindSupport.vue?vue&type=template&id=a856d924&scoped=true&"
import script from "./FindSupport.vue?vue&type=script&lang=ts&"
export * from "./FindSupport.vue?vue&type=script&lang=ts&"
import style0 from "./FindSupport.vue?vue&type=style&index=0&id=a856d924&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a856d924",
  null
  
)

export default component.exports